import clsx from 'clsx';
import { PropsWithChildren, useState } from 'react';
import LanguageSwitch from '../ui/LanguageSwitch';

interface StyledAuthContainerProps {
  title: string;
  footerMessage: string;
  footerLink: React.ReactNode;
}

const StyledAuthContainer = ({
  title,
  footerMessage,
  footerLink,
  children,
}: PropsWithChildren<StyledAuthContainerProps>) => {
  const [randomBgIndex] = useState(() => Math.floor(Math.random() * 5) + 1);

  return (
    <div
      className={clsx(
        'flex min-h-screen w-screen items-center justify-center bg-center bg-fixed bg-cover',
        {
          'bg-bg1': randomBgIndex === 1,
          'bg-bg2': randomBgIndex === 2,
          'bg-bg3': randomBgIndex === 3,
          'bg-bg4': randomBgIndex === 4,
          'bg-bg5': randomBgIndex === 5,
        },
      )}
    >
      <div className="flex flex-col items-center gap-8 px-9 py-8 w-96 h-fit border border-gray-200 rounded-lg bg-white">
        <div className="flex w-full flex-col items-center justify-between h-48">
          <img
            src="/images/ypt-logo.png"
            alt="Your Private Trip"
            className="h-24 w-52"
          />
          <h1 className="gap-3 text-3xl leading-8 font-semibold text-gray-900 w-full text-center">
            {title}
          </h1>
        </div>
        {children}
        <div className="flex flex-row w-full justify-center">
          <p className="text-sm leading-6 font-medium font-geist">
            {footerMessage}
          </p>
          {footerLink}
        </div>
        <div className="w-1/2 flex items-center justify-center">
          <LanguageSwitch />
        </div>
      </div>
    </div>
  );
};

export default StyledAuthContainer;
